import { Box, Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SettlementsList } from "Components/Settlements/SettlementsList";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { SettlementDownloadSection } from "Components/Transactions/UserTransactionFees/SettlementDownloadSection";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { isSettlementUserRole } from "Types/settlements";
import type { ReactNode } from "react";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

export const MerchantSettlementsPage = () => {
  const { t } = useResource();
  const currentUser = useLoggedInUser();
  const userRole = useCurrentUserRole();

  if (!currentUser?.partyPublicID || !isSettlementUserRole(userRole)) {
    return (
      <Layout>
        <ErrorText>{t(Resources.Pages.Content.Settlements.Error)}</ErrorText>
      </Layout>
    );
  }

  return (
    <Layout>
      <Stack gap={8}>
        <SettlementDownloadSection
          partyPublicID={currentUser.partyPublicID}
          userRole={userRole}
        />
        <SettlementsList
          partyPublicID={currentUser?.partyPublicID}
          userRole={AccessRoleCodes.Merchant}
        />
      </Stack>
    </Layout>
  );
};

export default MerchantSettlementsPage;

const Layout = ({ children }: { children: ReactNode }) => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Settlement)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <PrimaryPaper>{children}</PrimaryPaper>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
